import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Shield } from 'lucide-react';
import api from '@/lib/api';

export default function PrivacyPolicy() {
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/gdpr/privacy-policy')
      .then(res => setPolicy(res.data))
      .catch(() => setPolicy(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="flex justify-center py-20"><div className="animate-spin w-8 h-8 border-2 border-primary border-t-transparent rounded-full" /></div>;
  }

  return (
    <div className="max-w-3xl mx-auto space-y-4" data-testid="privacy-policy-page">
      <div>
        <h1 className="text-xl font-bold tracking-tight flex items-center gap-2">
          <Shield className="w-7 h-7 text-primary" />
          Privacy Policy
        </h1>
        <p className="text-muted-foreground mt-1">
          Last updated: {policy?.last_updated || 'N/A'}
        </p>
      </div>

      {(policy?.sections || []).map((section, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: i * 0.03 }}
        >
          <Card>
            <CardHeader className="pb-2">
              <CardTitle className="text-lg">{section.title}</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground leading-relaxed">{section.content}</p>
            </CardContent>
          </Card>
        </motion.div>
      ))}
    </div>
  );
}
